import * as types from './feed.actionTypes';

export const fetchFeedRequestActionCreator = () => {
  return { type: types.FETCH_FEED_REQUEST };
};

export const fetchStatisticsActionCreator = () => {
  return { type: types.FETCH_FEED_STATISTICS };
};

export const fetchPostStatisticsActionCreator = () => {
  return { type: types.FETCH_FEED_POST_STATISTICS };
};

export const fetchStatisticsSuccessActionCreator = statistics => {
  return { type: types.FETCH_FEED_STATISTICS_SUCCESS, statistics };
};

export const fetchPostStatisticsSuccessActionCreator = statistics => {
  return { type: types.FETCH_FEED_POST_STATISTICS_SUCCESS, statistics };
};

export const fetchFeedSuccessActionCreator = (feed,user) => {
  return { type: types.FETCH_FEED_SUCCESS, feed, user };
};

export const fetchFeedFailureActionCreator = error => {
  return { type: types.FETCH_FEED_FAILURE, error };
};

export const fetchStatisticsFailureActionCreator = error => {
  return { type: types.FETCH_FEED_STATISTICS_FAILURE, error };
};

export const fetchPostStatisticsFailureActionCreator = error => {
  return { type: types.FETCH_FEED_POST_STATISTICS_FAILURE, error };
};
export const deleteCardActionCreator = id => {
  return { type: types.DELETE_CARD, id };
};
export const setFeedUserIdActionCreator = uid => {
  return { type: types.SET_FEED_USER_ID, uid };
};

export const likeToggleActionCreator = id => {
  return { type: types.LIKE_TOGGLE, id };
};
export const replyLikeToggleActionCreator = (id,commentId,forFeed) => {
  return { type: types.REPLY_LIKE_TOGGLE, id, commentId, forFeed};
};
export const commentLikeToggleActionCreator = id => {
  return { type: types.COMMENT_LIKE_TOGGLE, id };
};
export const bookmarkToggleActionCreator = id => {
  return { type: types.BOOKMARK_TOGGLE, id };
};
export const fetchCommentsSuccessActionCreator = (id, data) => {
  return { type: types.FETCH_COMMENTS_SUCCESS, id, data };
};
export const commentOnPostSuccessActionCreator = (id, comment) => {
  return { type: types.COMMENT_ON_POST_SUCCESS, id, comment };
};
export const replyOnCommentCreator = (id, postId, comment) => {
  return { type: types.REPPLY_ON_COMMENT_SUCCESS, id, postId, comment };
};
export const clearFeedActionCreator = () => {
  return { type: types.CLEAR_FEED };
};
export const fetchPostRequestActionCreator = () => {
  return { type: types.FETCH_POST_REQUEST };
};
export const fetchPostSuccessActionCreator = post => {
  return { type: types.FETCH_POST_SUCCESS, post };
};
export const fetchPostFailureActionCreator = () => {
  return { type: types.FETCH_POST_FAILURE };
};

export const deletePostSuccessActionCreator = id => {
  return { type: types.DELETE_POST, id };
};
export const purchasePostSuccessActionCreator = post => {
  return { type: types.PURCHASE_POST_SUCCESS, post };
};

export const pinPostRequestActionCreator = () => {
  return { type: types.PIN_POST_REQUEST };
};

export const pinPostFailureActionCreator = () => {
  return { type: types.PIN_POST_FAILURE };
};

export const pinPostSuccessActionCreator = id => {
  return { type: types.PIN_POST_SUCCESS, id };
};
